// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__36nT9","footer":"ModalInfo_footer__1MbIq"};